import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { parseDomain, fromUrl } from "parse-domain";

import "./Layout.css";

import Header from "../Header";

import { getVendorByDomain } from "../../services/vendors";
import { fetchCurrentNotices } from "../../services/notices";

import {
  saveVendorId,
  saveCarriers,
  removeCarrierUserFromLS,
  fetchHiddenNotices,
  saveHiddenNotices,
  removeNoticesFromLS,
  saveVendorSSOSettings,
  persistItemToLS,
  storeCountriesAndStates,
  storeStateTitleTypes
} from "../../services/local-storage";
import {
  fetchCountriesAndStates,
  fetchStateTitleTypes
} from "../../services/locations";
import { logout } from "../../services/auth-request";
import Footer from "../Footer/Footer";
import NoticeBanner from "../NoticeBanner";
import { getAccountInfo } from "../../services/users";
import { Tooltip } from "react-tooltip";
import CreateNewClaimModal from "../CreateNewClaimModal";

export const formatSubdomain = () => {
  const { subDomains, domain } = parseDomain(fromUrl(window.location.href));
  let subDomain = subDomains?.length > 0 ? subDomains[0] : domain;
  if (
    process.env.NODE_ENV === "development" ||
    process.env.NODE_ENV === "staging"
  )
    subDomain = "";
  return subDomain;
};

const Layout = ({
  children,
  workPacket,
  showOrderMenu,
  mode,
  changeMode,
  revertMode,
  refreshPacket = () => {}
}) => {
  const [redirectToLogout, setRedirectToLogout] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [notices, setNotices] = useState(null);
  const [hiddenNotices, setHiddenNotices] = useState([]);
  const [carrier, setCarrier] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    (async function() {
      try {
        let vendor;
        let user;
        try {
          const subDomain = formatSubdomain();
          vendor = await getVendorByDomain(subDomain);
        } catch (ex) {
          console.log("Error getting vendor", ex);
        }

        try {
          user = await getAccountInfo();
          setCurrentUser(user);
          persistItemToLS("user", JSON.stringify(user));
        } catch (ex) {
          console.log("Error getting user", ex);
        }

        try {
          const userRequestingCompany = vendor?.carriers.find(
            c => c.requestingCompanyId === user.requestingCompanyId
          );
          setCarrier(userRequestingCompany || vendor.carriers[0]);

          saveVendorId(vendor.vendorId);
          saveVendorSSOSettings({
            userProvisioning: vendor.supportsUserProvisioning
          });
          saveCarriers(vendor.carriers);
        } catch (ex) {
          console.log("Error getting carriers", ex);
        }

        try {
          const validNotices = await fetchCurrentNotices();
          setNotices(validNotices);
          if (validNotices.length === 0) {
            removeNoticesFromLS();
          }
        } catch (ex) {
          console.log("Error getting notices", ex);
        }

        try {
          const locations = await fetchCountriesAndStates();

          storeCountriesAndStates(locations);
          console.log("locations", locations);
          const stateTitleTypes = await fetchStateTitleTypes();
          storeStateTitleTypes(stateTitleTypes);
        } catch (ex) {
          console.log("Error getting locations", ex);
        }
      } catch (ex) {
        console.log(ex);
        // await logout();
        // removeCarrierUserFromLS("user");
      }
    })();

    setHiddenNotices(fetchHiddenNotices());
  }, []);

  useEffect(() => {
    if (notices) {
      const validHiddenIds = hiddenNotices.filter(
        hN => notices.findIndex(n => n.noticeId === hN) > -1
      );

      saveHiddenNotices(validHiddenIds);
    }
  }, [hiddenNotices, notices]);

  const toggleUserMenu = () => {
    setShowUserMenu(!showUserMenu);
  };

  const signOut = async () => {
    await logout();
    removeCarrierUserFromLS("user");
    setRedirectToLogout(true);
  };

  const toggleNotice = noticeId => {
    setHiddenNotices(hidden => {
      hidden.push(noticeId);
      return [].concat(hidden);
    });
  };

  return (
    <div className="LayoutWrapper">
      {redirectToLogout && <Redirect to="/logout" />}

      <Header
        userMenuOpen={showUserMenu}
        toggleUserMenu={toggleUserMenu}
        signOut={signOut}
        carrier={carrier}
        currentUser={currentUser}
      />
      <div className="BannersContainer">
        {notices
          ? notices
              .filter(n => hiddenNotices.indexOf(n.noticeId) === -1)
              .map(notice => (
                <NoticeBanner
                  notice={notice}
                  key={notice.noticeId}
                  toggleNotice={toggleNotice}
                />
              ))
          : null}
      </div>
      <div className="LayoutContainer">{children}</div>

      {showOrderMenu && (
        <CreateNewClaimModal
          workingPacket={workPacket}
          refreshPacket={refreshPacket}
          mode={mode}
          changeMode={changeMode}
          revertMode={revertMode}
        />
      )}
      <Footer />
      <Tooltip
        id="lender-alias-tt"
        effect="solid"
        place={"left"}
        z-index={100000}
        opacity={1}
      />
    </div>
  );
};

export default Layout;
